import TransactionsView from '../../sections/admin/transactions/TransactionsView';
import { PATH_DASHBOARD } from '../../routes/paths';

export default function TransactionHistory() {
  return (
    <TransactionsView
      title="Transaction History"
      breadcrumbs={[
        { name: 'Admin', href: PATH_DASHBOARD.root },
        { name: 'Transactions', href: PATH_DASHBOARD.transactions.root },
        { name: 'Transaction History' },
      ]}
    />
  );
}
